import FamilyTransfersQuery from './FamilyTransfersQuery';
import OrganisationTransfersQuery from './OrganisationTransfersQuery';
import DemoTransfersQuery from './DemoTransfersQuery';
import NewFamilyTransfer from './new';
import NewOrganisationTransfer from './new-organisation';
import NewDemoTransfer from './new-demo';
import TransferDetailContainer from './TransferDetailContainer';
import CreditPlansQuery from './credit-plans';

const transferRoutes = [
  { path: '/accounts/:aid/family-transfers/', component: FamilyTransfersQuery, exact: true },
  { path: '/accounts/:aid/organisation-transfers/', component: OrganisationTransfersQuery, exact: true },
  { path: '/accounts/:aid/demo-transfers/', component: DemoTransfersQuery, exact: true },
  { path: '/accounts/:aid/family-transfers/new', component: NewFamilyTransfer },
  { path: '/accounts/:aid/organisation-transfers/new', component: NewOrganisationTransfer },
  { path: '/accounts/:aid/demo-transfers/new', component: NewDemoTransfer },
  { path: '/accounts/:aid/transfers/:transferId', component: TransferDetailContainer },
  { path: '/accounts/:aid/credit-plans/', component: CreditPlansQuery, exact: true },
];

export default transferRoutes;
